<template>
    <div class="MOrderView m-order" v-if="init">
        <mOrderHeader :item="item"></mOrderHeader>
        <div class="m-body">
            <div class="box">
                <div class="name">订单状态</div>
                <div class="value" :class="cls(item.status)">{{item.statustext}}</div>
            </div>
            <div class="box">
                <div class="name">订单编号</div>
                <div class="value">{{item.orderno}}</div>
            </div>
            <div class="box">
                <div class="name">订单时间</div>
                <div class="value">{{item.datetime}}</div>
            </div>
            <div class="box">
                <div class="name">商品原价</div>
                <div class="value">￥{{item.uprice}}</div>
            </div>
            <div class="box">
                <div class="name">商品现价</div>
                <div class="value">￥{{item.saleprice}}</div>
            </div>
            <div class="box">
                <div class="name">优惠券</div>
                <div class="value">-￥{{item.discountmoney}}</div>
            </div>
        </div>
        <div class="m-body">
            <div class="box">
                <div class="name">实际支付</div>
                <div class="value tc-red">￥{{item.finalpaymoney}}</div>
            </div>
        </div>
        <div class="btnBox" v-if="item.status!=30">
            <van-button class="cancel" type="default" @click="cancelOrder" v-if="item.status==9">取消订单</van-button>
            <van-button class="pay" type="default" v-if="item.status==9" @click="getPayUrl">去付款</van-button>
            <van-button class="pay" type="default" v-if="item.status==100" @click="gotoActivity">重新购买</van-button>
        </div>
    </div>
</template>

<script>
  import mOrderHeader from 'views/mobile/my/order/components/mOrderHeader'
  import {getOrderDetail, cancelMyOrderInfo} from 'api/systemApi'
  import {getPayResultInfo} from 'api/api'
  import {getOrderDetailByEnroll, cancelEventOrderByEnroll, getAaOrderPayUrl} from 'api/activeTools'
  import {mapActions, mapGetters} from 'vuex'
  import {orderCode, _setClass} from 'api/enumCode'


  export default {
    name: 'MOrderView',
    data() {
      return {
        init: false,
        item: {},
        orderno: this.$route.query.orderno ? this.$route.query.orderno : '',
        kmctype: this.$route.query.kmctype ? this.$route.query.kmctype : ''
      }
    },
    mounted() {
      if (!this.refresh) {
        if (this.kmctype == 13) {
          this._getOrderDetailByEnroll()
        } else {
          this.getView()
        }
      }
    },
    activated() {
      if (this.refresh) {
        this.orderno = this.$route.query.orderno ? this.$route.query.orderno : ''
        if (this.kmctype == 13) {
          this._getOrderDetailByEnroll()
        } else {
          this.getView()
        }
        this.setRefresh(false)
      }
    },
    methods: {
      gotoActivity() {
        this.setRefresh(true)
        this.$router.push({name: 'ActivityDetail', query: {eventid: this.item.courseid}})
      },
      cancelOrder() {
        this.$dialog.confirm({
          title: '提示',
          message: '确定取消订单？'
        }).then(() => {
          if (this.kmctype == 13) {
            this._cancelEventOrderByEnroll()
          } else {
            this._cancelMyOrderInfo()
          }
        }).catch(() => {
          this.$router.back()
        })
      },
      _cancelMyOrderInfo() {
        this.setLoading(true)
        cancelMyOrderInfo({
          data: {orderno: this.orderno},
          success: () => {
            this.setLoading(false)
            this.item.status = 100
            this.$toast.success('操作成功')
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      _cancelEventOrderByEnroll() {
        this.setLoading(true)
        cancelEventOrderByEnroll({
          data: {orderno: this.orderno},
          success: () => {
            this.setLoading(false)
            this.item.status = 100
            this.$toast.success('操作成功')
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      getPayUrl() {
        if (this.kmctype == 13) {
          this._getAaOrderPayUrl()
        } else {
          this._getPayUrl()
        }
      },
      _getPayUrl() {
        this.setLoading(true)
        getPayResultInfo({
          data: {orderno: this.orderno},
          success: data => {
            this.setLoading(false)
            window.location.href = data.data.url
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      _getAaOrderPayUrl() {
        this.setLoading(true)
        getAaOrderPayUrl({
          data: {orderno: this.orderno},
          success: data => {
            this.setLoading(false)
            window.location.href = data.data
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      getView() {
        this.setLoading(true)
        getOrderDetail({
          data: {orderno: this.orderno},
          success: data => {
            this.setLoading(false)
            this.init = true
            this.item = data.data
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      _getOrderDetailByEnroll() {
        this.setLoading(true)
        getOrderDetailByEnroll({
          data: {orderno: this.orderno},
          success: data => {
            this.setLoading(false)
            this.init = true
            this.item = data.data
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
      cls() {
        return function (value) {
          return _setClass(value, orderCode.status)
        }
      },
      ...mapGetters(['refresh'])
    },
    components: {
      mOrderHeader
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";
    @import "~views/mobile/my/order/order";

    .MOrderView {
        .btnBox {
            margin-top: 0.12rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .van-button {
                box-sizing: border-box;
                flex-grow: 1;
                height: 0.7rem;
                line-height: 0.7rem;
                border-radius: 0.38rem;
                font-size: 0.3rem;
                padding: 0;
                text-align: center;
            }
            .van-button + .van-button {
                margin-left: 0.32rem;
            }
            .cancel {
                color: #C0C4CC;
                border-color: #C0C4CC;
            }
            .pay {
                color: $c-white;
                background: $c-red;
                border-width: 0;
            }
        }
        .m-body {
          padding: 0 0.32rem;
          .box {
            line-height: 1.1rem;
            .name {
              color: #999999;
            }
            &:not(:last-of-type) {
              border-bottom: 0.01rem solid #E5E5E5;
            }
          }
        }
    }
</style>